import React, { useState, useEffect } from 'react';
import { aboutText, businessInfo } from '../mock';
import { MapPin, Phone, Mail } from 'lucide-react';
import YearsPopup from '../components/YearsPopup';

const AboutPage = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Show popup every time user visits the about page
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen">
      {/* 52 Years Popup */}
      <YearsPopup isOpen={showPopup} onClose={() => setShowPopup(false)} />
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white py-32 md:py-40">
        <div className="absolute inset-0">
          <img 
            src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/dandie_store_streetsville_c1900-1920w.webp"
            alt="Historical Streetsville"
            className="w-full h-full object-cover opacity-30"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About Streetsville Eyecare</h1>
          <p className="text-xl">Serving the community since 1974</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/dandie_store_streetsville_c1900-1920w.webp"
                  alt="Historical Streetsville circa 1900"
                  className="w-full h-[500px] md:h-[600px] object-cover"
                />
              </div>
              <div className="space-y-6">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                  {aboutText.heading}
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  {aboutText.description}
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid md:grid-cols-3 gap-8 mb-16">
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl font-bold text-red-600 mb-2">52+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl font-bold text-red-600 mb-2">1000+</div>
                <div className="text-gray-600">Happy Clients</div>
              </div>
              <div className="text-center p-6 bg-gray-50 rounded-xl">
                <div className="text-4xl font-bold text-red-600 mb-2">100+</div>
                <div className="text-gray-600">Designer Brands</div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gray-50 rounded-xl p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Visit Us</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-red-600 mt-1" />
                  <div>
                    <p className="font-medium text-gray-900">{businessInfo.address.street}</p>
                    <p className="text-gray-600">{businessInfo.address.unit}</p>
                    <p className="text-gray-600">{businessInfo.address.city}, {businessInfo.address.province} {businessInfo.address.postalCode}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-red-600" />
                  <a href={`tel:${businessInfo.phone}`} className="text-gray-600 hover:text-red-600">{businessInfo.phone}</a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-red-600" />
                  <a href={`mailto:${businessInfo.email}`} className="text-gray-600 hover:text-red-600">{businessInfo.email}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
